/*
 * What the inspector records on the move itself, as opposed to what the yard already knows about the
 * unit: reefer readings, the genset's fuel, the container's seals and hazard. These are editable on both
 * gate directions; everything else a lookup returns is the yard's to refresh.
 */
export const INSPECTED_FIELDS = [
  'temperature',
  'humidity',
  'ventilation',
  'fuelLevel',
  'seal0',
  'seal1',
  'seal2',
  'hazard'
] as const;

export type InspectedField = (typeof INSPECTED_FIELDS)[number];

type InspectedUnit = { id?: number | null } & Partial<Record<InspectedField, unknown>>;

/*
 * The unit a lookup loaded, keeping what the inspector recorded on this move when it is the unit already
 * in the column. The unit field re-validates whenever the form mounts — coming back from review, or after
 * a draft reload — and each time replaced the whole unit with its stored copy, erasing whatever had been
 * typed, and the reefer values the booking had filled. A different unit still replaces everything.
 */
export const keepInspectedValues = <T extends InspectedUnit>(current: T | undefined, loaded: T): T => {
  if (!current?.id || current.id <= 0 || current.id !== loaded.id) return loaded;
  const kept = { ...loaded };
  INSPECTED_FIELDS.forEach(field => {
    (kept as InspectedUnit)[field] = current[field];
  });
  return kept;
};
